import { action } from 'mobx';
import BaseStore from 'core/stores/BaseStore';
import { PalletService } from 'common/data';

class PalletStore extends BaseStore {
	constructor(rootStore) {
		super(new PalletService(rootStore.app.baasic.apiClient));
	}

	@action async findPallet(filter) {
		const response = await this.service.find(filter);
		if (filter && filter.search) {
			response.data.searchQuery = filter.search;
		}
		this.response = response.data;
	}

	@action async getPallet(id, options) {
		const pallet = await this.service.get(id, options);
		this.item = pallet.data;
	}

	@action async exitScan(resource, sourceOfChange) {
		await this.service.exitScan(resource, sourceOfChange);
	}

	@action async updatePallet(pallet, sourceOfChange) {
		await this.service.update(pallet, sourceOfChange);
	}
}

export default PalletStore;
